import script from "./stmn-agncy-cnsg-rqt-compt.vue?vue&type=script&setup=true&lang=js"
export * from "./stmn-agncy-cnsg-rqt-compt.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__